<template>
  <a
    :href="brandData.linkUrl"
    :tracking="tracking"
    @click="handleClick"
  >
    <img
      :loading="loading"
      :src="brandData.imgSrc"
      :alt="brandData.imgAlt"
      :width="brandData.logoWidth"
      :height="brandData.logoHeight"
    >
  </a>
</template>
<script>

  export default {
    props: {
      /**
       * @param brandData Object REQUIRED!
       * @property linkUrl, url used when clicked on logo. REQUIRED!
       * @property imgSrc, source of the image to display. REQUIRED!
       * @property imgAlt, alt of the image. REQUIRED!
       * @property logoHeight, height of the image
       * @property logoWidth, widht of the image
       */
      brandData: {
        type: Object,
        required: true,
        validator: (data) => data.linkUrl && data.imgSrc && data.imgAlt,
      },
      loading: {
        type: String,
        default: 'lazy',
        validator: (value) => ['', 'lazy', 'eager'].includes(value),
      },
      tracking: {
        type: String,
        default: '',
      },
    },
    methods: {
      handleClick() {
        this.$emit('logo:clicked', { tracking: this.tracking });
      },
    },
  };
</script>
